import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button-component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgIf, SvgIconComponent]
})
export class IconButtonComponent {
    @Input() public variant: 'primary' | 'secondary' | 'blue';
    @Input() public iconName: string;
    @Input() public type: 'submit' | 'reset' | 'button' = 'button';
    @Input() public fullWidth: boolean;
    @Input() public fullHeight: boolean;
    @Input() public iconOnly: boolean;
    @Input() public iconPosition: 'before' | 'after' = 'before';

    @HostBinding('class.disabled')
    @Input()
    public disabled: boolean;
}
